export const messages = {
  self_request:
    "This is where you define the user acces request, make sure to select 'for myself' if you are requesting for your access only. Other users cannot be added in this option. Otherwise, select the other option.",
  multiple_users_request:
    "This option allows you to submit request for multiple users including yourself.",
  user_not_found:
    //"Sorry, I can’t find your records. You may click [HERE](/feedback) to report this feedback. Rest assured that this will be attended with urgency.",
    "Sorry, I can’t find your records. You may click [HERE](https://docs.google.com/forms/d/e/1FAIpQLSdzRcCIJwKDEJBtXObCTVkj1WaHJRNpvC0xpcWRHLnFxS8ElA/viewform?usp=sf_link) to request for registration. Rest assured that this will be attended with urgency.",
  missing_user_id: "Please input your Employee ID.",
};
